import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03a2c732"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "WargingMessage_Content" }
const _hoisted_2 = { class: "WargingMessage_Main" }
const _hoisted_3 = {
  class: "bold",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_4 = { class: "WargingMessage_BtnBlock" }

import BtnGreen from "../atoms/button/BtnGreen.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalConfirm',
  props: {
  message: { type: String },
},
  emits: ["close", "execute"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

const closeModal = () => {
  emit("close");
};
const execute = (isSave: boolean) => {
  emit("execute", isSave);
  closeModal();
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "WargingMessage",
      onClick: closeModal
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'exclamation-triangle'],
          class: "icon__save__filed"
        }),
        _createElementVNode("p", _hoisted_3, _toDisplayString(props.message), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BtnGreen, {
            class: "btn_gray",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("キャンセル")
            ]),
            _: 1
          }),
          _createVNode(BtnGreen, {
            class: "btn_blue",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (execute(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("いいえ")
            ]),
            _: 1
          }),
          _createVNode(BtnGreen, {
            class: "btn_red",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (execute(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("はい")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})